<template>
  <v-container background fluid pa-3 v-scroll="onScrollFunction" class="contain_width">
    <div id="search_box" class="searching_box">
      <v-text-field
        v-show="show_search"
        name="search_item"
        v-model="Search_data"
        @input="searchProcess()"
        label="ค้นหา..."
        style="margin-top:7px;color:#fff"
        flat
        color="white"
        class="search_text"
        append-icon
        clearable
      />
    </div>
    <filter-component :json_data="form_dialog_data" v-on:set="onCloseFormDialog" />

    <v-btn slot="activator" icon @click="searchClick()" class="btn_show_search">
      <v-icon :size="16">fa-search</v-icon>
    </v-btn>

    <v-btn slot="activator" icon @click="showFilter(true)" class="btn_show_filter">
      <v-icon :size="16">fa-filter</v-icon>
    </v-btn>

    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page_flex">
        <v-text-field solo label="ค้นหา..." v-model="Search_data" @input="searchProcess()" append-icon="search" style="margin-bottom: 0px;"></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page">
        <v-text-field solo label="ค้นหา..." v-model="Search_data" @input="searchProcess()" append-icon="search" style="margin-bottom: 0px;"></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <!-- Create Button -->
      <v-flex md12 sm12 xs12 v-if="permission_edit == true || admin == 'true'">
        <!-- <v-tooltip top> -->
        <v-btn color="primary" dark fixed bottom right fab @click="add()">
          <v-icon>fa-plus</v-icon>
        </v-btn>
        <!-- <span>{{$t('create')}}</span>
        </v-tooltip> -->
      </v-flex>
      <v-layout row align-center text-xs-center style="margin-top:5rem;margin-bottom:15rem" v-if="table_data.length == 0 && !showLoading">
        <v-flex xs12 md4 offset-md4 lg2 offset-lg5 class="adddoc-hover" style="cursor: pointer" v-if="permission_edit == true || admin == 'true'">
          <v-tooltip top>
            <template slot="activator">
              <div @click="add()" style="padding-top:40px;padding-bottom:40px;">
                <v-icon style="font-size:80px;" color="blue">fa fa-plus</v-icon>
                <h3 class="headline mb-0" style="color:#2195F3;">{{ $t("AddDocumentIncome") }}</h3>
              </div>
            </template>
            <span>{{ $t("create") }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <!-- List -->
      <v-flex md12 sm12 xs12>
        <v-layout row wrap v-if="!showLoading">
          <v-flex lg6 md6 sm12 xs12 pa-1 v-for="(item, index) in table_data" :key="index">
            <v-layout row warp>
              <v-flex md12 sm12 xs12>
                <v-card class="coco-box-shadow " style="border-left:5px solid #408550;border-radius:5px;">
                  <v-layout row wrap class="coco-list-layout" pa-3>
                    <!-- <div class="triangle-topright"></div> -->
                    <v-flex lg1 md1 sm1 xs2 text-xs-center style="margin:auto">
                      <v-icon :size="50" style="color:#408550;">
                        fas fa-file-invoice-dollar
                      </v-icon>
                    </v-flex>
                    <v-flex lg8 md8 sm8 xs7 text-xs-left style="padding-left:15px;">
                      <v-layout row wrap style="color:rgba(0,0,0,0.54)">
                        <v-flex xs12>
                          <v-layout row wrap>
                            <v-flex lg5 md4 sm4 xs12>
                              <strong>{{ $t("DocumentID") }} : </strong>
                            </v-flex>
                            <v-flex lg6 md7 sm6 xs12 style="margin-left:5px;">
                              <span>{{ item.code }}</span>
                            </v-flex>
                            <v-flex lg5 md6 sm4 xs12>
                              <strong>{{ $t("Document creation date") }} : </strong>
                            </v-flex>
                            <v-flex lg6 md4 sm6 xs12 style="margin-left:5px;">
                              <span>{{ formatdate(item.date) }}</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12>
                          <v-layout row wrap>
                            <v-flex lg5 md6 sm4 xs12>
                              <strong>{{ $t("Document creator") }} : </strong>
                            </v-flex>
                            <v-flex lg6 md4 sm6 xs12 style="margin-left:5px;">
                              <span>{{ item.creator_code }}</span>
                            </v-flex>
                            <v-flex lg12 md12 sm12 xs12 v-if="item.remark != ''">
                              <v-icon>info</v-icon>
                              <span> {{ item.remark }}</span>
                            </v-flex>
                            <v-flex lg12 md12 sm12 xs12 v-if="item.remark == ''">
                              <v-icon>info</v-icon>
                              <span> -</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex lg1 md1 sm1 xs2>
                      <v-layout row wrap>
                        <v-flex lg1 md2 sm2 xs2 text-xs-right>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-menu offset-y>
                              <template slot="activator">
                                <v-btn icon style="color:rgba(0,0,0,0.54)">
                                  <v-icon>fas fa-ellipsis-v</v-icon>
                                </v-btn>
                              </template>
                              <v-card class="pa-0" max-width="344">
                                <v-card-title class="setbox" v-if="permission_view == true || admin == 'true'">
                                  <v-btn color="orange" slot="activator" flat @click="viewdetail(item.code)">
                                    <v-icon>search</v-icon>
                                    <span> {{ $t("view") }}</span>
                                  </v-btn>
                                </v-card-title>
                                <v-card-title class="setbox" v-if="permission_edit == true || admin == 'true'">
                                  <v-btn color="red" flat @click="deleteItem(item.code)">
                                    <v-icon>delete</v-icon>
                                    <span> {{ $t("delete") }}</span>
                                  </v-btn>
                                </v-card-title>
                              </v-card>
                            </v-menu>
                          </v-card-actions>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>

            <!-- <v-card class="coco-box-shadow coco-list-hover" style="border-left:5px solid #408550;">
              <v-layout align-center justify-center row fill-height wrap class="coco-list-layout" style=" padding-top: 10px;">
                  <v-flex lg1 md1 sm2 xs3 text-xs-center> -->
            <!-- <v-avatar
                    v-if="item.emp_images == '' || item.emp_images == undefined  || item.emp_images == null"
                    :size="64"
                    color="teal"
                  >
                    <span class="white--text headline">{{item.nick_name}}</span>
                  </v-avatar> -->
            <!-- <v-icon :size="64" style="color:#408550">
                    fas fa-file-alt
                  </v-icon>
                </v-flex>
                <v-flex lg9 md9 sm8 xs9>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-layout row wrap>
                        <v-flex md6 sm12 xs12>
                          <span class="coco-list-label-text">{{$t('DocumentID')}} :</span>
                          <span>{{item.code }}</span>
                        </v-flex>
                        <v-flex md6 sm12 xs12>
                          <span class="coco-list-label-text">{{$t('Document creation date')}} :</span>
                          <span>{{formatdate(item.date)}}</span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout row wrap>
                        <v-flex md6 sm12 xs12>
                          <span class="coco-list-label-text">{{$t('Document creator')}} :</span>
                          <span>{{item.creator_code}}</span>
                        </v-flex>
                        <v-flex md6 sm12 xs12 v-if="item.remark != ''">
                          <v-icon>info</v-icon>
                          <span>{{item.remark}}</span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex lg2 md2 sm4 xs12>
                  <v-layout row wrap>
                    <v-flex md12 sm12 xs12 text-xs-center>
                      <v-layout row wrap>
                        <v-flex offset-lg5 offset-md3 offset-sm6 offset-xs8 lg3 md4 sm3 xs2 v-if="check_permission == true || admin == 'true'">
                          <v-btn
                            color="orange"
                            slot="activator"
                            icon
                            flat
                            @click="viewdetail(item.code)"
                          >
                            <v-icon>search</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex lg3 md4 sm3 xs2  v-if="check_permission == true || admin == 'true'">
                          <v-btn color="red" icon flat @click="deleteItem(item.code)">
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="coco-list-divider" style="margin-top : 10px;">
                  <v-divider />
                </v-flex>
              </v-layout>
            </v-card> -->
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- pagination -->
      <v-layout row wrap my-2>
        <v-flex xs12>
          <div class="show_pagination_fixed">
            <v-pagination fixed v-model="pageActive" :length="totalPages" :total-visible="7" circle @input="getIncomeList('List')"></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      <!-- Delete Dialog -->
      <v-flex md12 sm12 xs12>
        <delete-dialog :json_data="delete_dialog_data" v-on:close-dialog="onCloseDeleteDialog" v-on:delete-item="onDelete" />
      </v-flex>
      <!-- FormEdit -->
      <v-layout row justify-center>
        <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn
                icon
                dark
                @click="
                  dialog = false;
                  close();
                "
              >
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>{{ form_dialog.code }} ({{ formatdate(form_dialog.date) }})</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-title style="font-size:20px;"></v-card-title>
            <v-card-text>
              <v-container grid-list-xs class="back-ground-none">
                <v-layout row wrap>
                  <v-flex md2 sm6 xs12>
                    <v-text-field :label="$t('DocumentID')" v-model="form_dialog.code" required readonly></v-text-field>
                  </v-flex>
                  <v-flex md1 sm1 xs1></v-flex>
                  <v-flex md2 sm6 xs12>
                    <v-text-field :label="$t('Document creation date')" v-model="form_dialog.date" required readonly></v-text-field>
                  </v-flex>
                  <v-flex md1 sm1 xs1></v-flex>
                  <v-flex md6 sm6 xs12>
                    <v-text-field :label="$t('remark')" v-model="form_dialog.remark" required></v-text-field>
                  </v-flex>
                </v-layout>

                <v-flex
                  md12
                  sm12
                  xs12
                  v-for="(item, index) in IncomeData"
                  :key="index"
                  @click="
                    '';

                  "
                >
                  <v-card class="coco-box-shadow coco-list-hover">
                    <v-layout align-center justify-center row fill-height wrap class="coco-list-layout">
                      <v-flex lg1 md1 sm2 xs3 text-xs-center>
                        <v-avatar :size="64">
                          <v-avatar v-if="item.emp_images == '' || item.emp_images == undefined || item.emp_images == null" :size="64" color="teal">
                            <span class="white--text headline">{{ item.nick_name }}</span>
                          </v-avatar>

                          <Empimage v-if="item.emp_images != '' && item.emp_images != undefined && item.emp_images != null" :json_data="item.emp_images" />
                        </v-avatar>
                      </v-flex>
                      <v-flex lg9 md9 sm8 xs9>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <span class="coco-list-label-text">{{ isEmpty(item.emp_code) ? item.emp_code : "" }}:</span>
                            <span>{{ item.name_title }} {{ item.first_name }} {{ item.last_name }}</span>
                            <span v-html="' <span style=color:#166BFF;>' + (isEmpty(item.nick_name) ? '('+item.nick_name+')' : '') + '</span>'" />
                          </v-flex>
                          <v-flex xs12 class="hidden-xs-only">
                            <span class="coco-list-label-text hidden-sm-only">
                              {{ $t("branch") }}:
                              <span>
                                {{ isEmpty(item.branch) ? item.branch : "" }}
                              </span>
                            </span>
                            <span class="coco-list-label-text hidden-sm-only">
                              {{ $t("Department") }}:
                              <span>
                                {{ isEmpty(item.department_name) ? item.department_name : "" }}
                              </span>
                            </span>
                            <span class="coco-list-label-text hidden-sm-only">
                              {{ $t("Position") }}:
                              <span>
                                {{ isEmpty(item.position) ? item.position : "" }}
                              </span>
                            </span>
                            <span class="coco-list-label-icon">
                              <v-icon>access_time</v-icon>
                              <span>{{ formatdate(item.effect_date) }}</span>
                            </span>
                            <span class="coco-list-label-icon">
                              <v-icon>monetization_on</v-icon>
                              <span v-show="currencySymbols == '0'">{{ symbolStyles + " " + formatNumber(item.amount, 2, true) }}</span>
                              <span v-show="currencySymbols == '1'">{{ formatNumber(item.amount, 2, true) + " " + symbolStyles }}</span>
                            </span>
                            <span class="coco-list-label-icon">
                              <v-icon>info</v-icon>
                              <span>{{ isEmpty(item.name) ? item.name : "-" }}</span>
                            </span>
                          </v-flex>
                          <v-flex xs12 class="hidden-sm-and-up">
                            <span class="coco-list-label-icon">
                              <v-icon style="padding-left: 0px;">access_time</v-icon>
                              <span>{{ formatdate(item.effect_date) }}</span>
                            </span>
                            <span class="coco-list-label-icon">
                              <v-icon>monetization_on</v-icon>
                              <span v-show="currencySymbols == '0'">{{ symbolStyles + " " + formatNumber(item.amount, 2, true) }}</span>
                              <span v-show="currencySymbols == '1'">{{ formatNumber(item.amount, 2, true) + " " + symbolStyles }}</span>
                            </span>
                          </v-flex>
                          <v-flex xs12 class="hidden-sm-and-up">
                            <span class="coco-list-label-icon">
                              <v-icon style="padding-left: 0px;">info</v-icon>
                              <span>{{ isEmpty(item.name) ? item.name : "-" }}</span>
                            </span>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex lg4 md6 sm6 xs12 pa-1>
                            <span class="coco-list-label-text hidden-sm-only">
                              {{ $t("branch_pay") }}:
                              <span>
                                {{ isEmpty(item.branch_pay) ? item.branch_pay : "" }}
                              </span>
                            </span>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex lg4 md6 sm6 xs12>
                            <v-checkbox :label="$t('not_cal_tax')" value="1" v-model="item.not_cal_tax" disabled />
                          </v-flex>
                          <v-flex lg4 md6 sm6 xs12>
                            <v-checkbox label="รวมรายได้ในประกันสังคม" :value="1" v-model="item.not_cal_ss" disabled />
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex lg2 md2 sm2 xs2>
                        <v-layout row wrap class="hidden-xs-only">
                          <v-flex md12 sm12 xs12 text-xs-center>
                            <v-layout row wrap>
                              <v-flex offset-lg5 offset-md3 lg3 md4 xs6>
                                <v-tooltip bottom>
                                  <v-btn slot="activator" color="warning" icon flat @click="EditItem(item, index)">
                                    <v-icon>edit</v-icon>
                                  </v-btn>
                                  <span>{{ $t("edit") }}</span>
                                </v-tooltip>
                              </v-flex>
                              <v-flex lg3 md4 xs6>
                                <v-tooltip bottom>
                                  <v-btn slot="activator" color="error" icon flat @click="deleteItemlistemp(item, index)">
                                    <v-icon>delete</v-icon>
                                  </v-btn>
                                  <span>{{ $t("delete") }}</span>
                                </v-tooltip>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex xs12 offset-md1 offset-sm2 class="coco-list-divider">
                        <v-divider />
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    flat
                    @click="
                      dialog = false;
                      close();
                    "
                    >{{ $t("close") }}</v-btn
                  >
                  <v-btn
                    color="blue darken-1"
                    flat
                    @click="
                      dialog = false;
                      UpdateIncome();
                    "
                    >{{ $t("save") }}</v-btn
                  >
                </v-card-actions>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- FormEdit -->
      <v-layout row justify-center>
        <v-dialog v-model="editdialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ form_editdialog.emp_code }} : {{ form_editdialog.first_name }}&nbsp;{{ form_editdialog.last_name }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('amount')" v-model="form_editdialog.amount" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('detail')" v-model="form_editdialog.name" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field label="วันที่มีผล" v-model="form_editdialog.effect_date" required></v-text-field>
                  </v-flex>
                  <v-flex md6 sm6 xs12 pa-1>
                    <v-select :items="tax_type" :label="$t('TaxType')" v-model="form_editdialog.tax_type" item-text="text" item-value="code"></v-select>
                  </v-flex>
                  <v-flex md6 sm6 xs12 pa-1>
                    <v-text-field :label="$t('TaxPercent')" v-model="form_editdialog.tax_percent" required type="number" hide-details />
                  </v-flex>
                  <v-flex md6 sm6 xs12 pa-1>
                    <v-text-field :label="$t('branch_pay')" v-model="form_editdialog.branch_pay"  hide-details />
                  </v-flex>
                  <v-layout row wrap>
                    <v-flex xs12 pa-1>
                      <v-checkbox :label="$t('not_cal_tax')" value="1" v-model="form_editdialog.not_cal_tax" />
                    </v-flex>
                    <v-flex xs12 pa-1>
                      <v-checkbox label="รวมรายได้ในประกันสังคม" :value="1" v-model="form_editdialog.not_cal_ss" />
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="editdialog = false">{{ $t("close") }}</v-btn>
              <v-btn
                color="blue darken-1"
                flat
                @click="
                  editdialog = false;
                  onUpdate();
                "
                >{{ $t("update") }}</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!--  delete -->
      <v-layout row justify-center>
        <v-dialog v-model="deldialog" persistent max-width="300px">
          <v-toolbar color="red">DELETE</v-toolbar>
          <v-card>
            <v-card-title>
              <span text-xs-center>{{ $t("question.delete") }}</span>
              <br />
              <span text-xs-center>{{ form_deldialog.emp_code }}:{{ form_deldialog.first_name }}{{ form_deldialog.last_name }}</span>
            </v-card-title>
            <v-card-text></v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="deldialog = false">Close</v-btn>
              <v-btn
                color="blue darken-1"
                flat
                @click="
                  deldialog = false;
                  onDeleteEmp();
                "
                >delete</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- Snackbar -->
      <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :color="snack_model.type">
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import DocumentService from "@/services/DocumentService";
import Empimage from "../../components/getempimage.vue";
import DeleteDialog from "../../components/master/dialogs/DeleteDialog";
import Utils from "@/utils/";
import UserService from "@/services/UserService";
import moment from "moment";
import $ from "jquery";
import FilterComponent from "./Filter";
export default {
  data: () => ({
    Search_data: "",
    show_search: false,
    timeout: null,
    form_dialog_data: {
      status: false,
    },
    form_dialog: {
      code: "",
      remark: "",
      date: "",
      creator_code: localStorage._usercode,
      details: [],
      company_id: localStorage._company_id,
    },
    delete_dialog_data: {
      status: false,
    },
    snack_model: {
      status: "",
      msg: "",
      type: "",
    },
    form_editdialog: {
      amount: "",
      name: "",
      emp_code: "",
      detailincome: "",
      effect_date: "",
    
    },
    form_deldialog: {
      amount: "",
      name: "",
      emp_code: "",
      detailincome: "",
      effect_date: "",
    },
    tax_type: [
      { code: "1", text: "มาตรา40(1) ค่าจ้างเงินเดือน" },
      { code: "2", text: "มาตรา40(2) ค่านายหน้า ค่าคอม" },
      { code: "3", text: "มาตรา40(3) ค่าลิขสิทธิ์" },
      { code: "4", text: "มาตรา40(4) ดอกเบี้ยเงินปันผล" },
      { code: "5", text: "มาตรา40(5) ค่าเช่า" },
      { code: "6", text: "มาตรา40(6) ค่าวิชาชีพอิสระ" },
      { code: "7", text: "มาตรา40(7) ค่ารับเหมา" },
      { code: "8", text: "มาตรา40(8) เงินได้อื่นๆ" },
    ],
    table_data: [],
    dialog: false,
    editdialog: false,
    deldialog: false,
    pageActive: 1,
    totalPages: 0,
    processing: false,
    canLoadMore: true,
    IncomeData: [],
    index: 0,
    mini: false,
    drawer: "",
    permission_edit: false,
    permission_view: false,
    admin: false,
    empCode: localStorage._empcode,
    permission: [],
  }),
  created: async function() {
    this.setSearchData({ value: "" });

    await UserService.getpermissionByusercode(this.empCode)
      .then((res) => {
        this.permission = res.data.permission;
        console.log(res);
      })
      .catch((err) => {});
    await this.checkpermission("ImportFileIncome");
    this.admin = localStorage._is_admin;
    console.log(this.check_permission);
    // this.setShowFilter({
    //   status: 1
    // });

    this.commitSetToolbar({
      patternTool: "0",
    });
    this.getIncomeList("Form");

    // this.$store.watch(
    //   state => {
    //     state.filter.SelectBranch;
    //     state.filter.SelectDepartment;
    //     state.filter.SelectPosition;
    //     state.filter.FromDate;
    //     state.filter.ToDate;
    //   },
    //   () => {
    //     this.pageActive = 1;
    //     this.table_data = [];
    //     this.canLoadMore = true;
    //     this.getIncomeList("Filter");
    //     //console.log("active");
    //   },
    //   {
    //     deep: true
    //   }
    // );
  },
  destroyed: function() {
    this.commitToggleAlertDialog({
      status: false,
      message: Object,
    });
  },
  components: {
    Empimage,
    DeleteDialog,
    FilterComponent,
  },
  computed: {
    ...mapState("filter", ["SelectBranch", "SelectDepartment", "SelectPosition", "SearchData", "FromDate", "ToDate"]),
    ...mapState("app", ["showLoading", "formatDates", "symbolStyles", "currencySymbols"]),
    //...mapState("permissionmenu", ["permission_List"]),

    SearchEmp: {
      get() {
        return this.SearchData;
      },
      async set(newValue) {
        await this.setSearchData({ value: newValue });
      },
    },
  },
  methods: {
    ...mapActions("filter", ["setSearchData"]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),

    goto(path) {
      this.$router.push("/" + path);
    },
    onCloseFormDialog(value) {
      this.form_dialog_data.status = false;
      this.onload = true;
      console.log("5555", this.FromDate);
      console.log("666", this.ToDate);
      this.getIncomeList("Form");
    },
    checkpermission(page) {
      let checkEdit = false;
      let checkView = false;
      if (this.permission.length != 0) {
        this.permission.forEach((element) => {
          if (page == element.module_name) {
            checkEdit = element.edit;
            checkView = element.reads;
          }
        });
      } else {
        checkEdit = false;
        checkView = false;
      }
      this.permission_edit = checkEdit;
      this.permission_view = checkView;
    },
    unwatch() {
      this.$store.watch();
    },
    add() {
      this.goto("ImportFile/ImportFileIncome");
    },
    close() {
      this.form_dialog.details = [];
      console.log(this.form_dialog.details);
    },
    EditItem(data, index) {
      this.editdialog = true;
      this.form_editdialog = data;
      this.index = index;
      console.log(this.form_editdialog);
    },
    onUpdate() {
      let v = this;
      if (v.form_editdialog.not_cal_tax == null) {
        v.form_editdialog.not_cal_tax = "0";
      }
      if (v.form_editdialog.company_pay == null) {
        v.form_editdialog.company_pay = "0";
      }
      (v.form_dialog.details[v.index].emp_code = v.form_editdialog.emp_code),
        (v.form_dialog.details[v.index].effect_date = v.form_editdialog.effect_date),
        (v.form_dialog.details[v.index].name = v.form_editdialog.name),
        (v.form_dialog.details[v.index].amount = v.form_editdialog.amount),
        (v.form_dialog.details[v.index].not_cal_tax = v.form_editdialog.not_cal_tax),
        (v.form_dialog.details[v.index].company_pay = v.form_editdialog.company_pay),
        (v.form_dialog.details[v.index].tax_type = v.form_editdialog.tax_type),
        (v.form_dialog.details[v.index].tax_percent = v.form_editdialog.tax_percent),
        (v.form_dialog.details[v.index].branch_pay = v.form_editdialog.branch_pay),
        (v.form_dialog.details[v.index].not_cal_ss = v.form_editdialog.not_cal_ss),
        
        (this.snack_model.status = true);
      this.snack_model.msg = this.$t("message.update");
      this.snack_model.type = "success";
      console.log(v.form_dialog);
    },
    UpdateIncome() {
      console.log(this.form_dialog);
      this.form_dialog.company_id = localStorage._company_guid;
      DocumentService.updateIncome(this.form_dialog)
        .then((res) => {
          this.snack_model.status = true;
          this.snack_model.msg = this.$t("message.update");
        //  location.reload();
        })
        .catch((err) => {
          this.snack_model.status = true;
          this.snack_model.msg = err;
          this.snack_model.type = "error";
        });
    },
    onCloseDialog() {
      this.pageActive = 1;
      this.table_data = [];
      this.form_dialog_data.status = false;
      this.getIncomeList();
    },
    onCloseDeleteDialog() {
      this.delete_dialog_data.status = false;
    },
    formatNumber(value, digit, hasComma) {
      return Utils.formatNumber(value, digit, hasComma);
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },

    formatdate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    searchProcess() {
      var v = this;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        v.getIncomeList("Filter");
      }, 1500);
    },
    searchClick() {
      if (this.show_search) {
        this.show_search = false;
        $("#pagetitleshow").removeClass("showtitlepage");
      } else {
        this.show_search = true;
        $("#pagetitleshow").addClass("showtitlepage");
      }
    },
    showFilter(status) {
      this.form_dialog_data = {
        status: status,
        data: 1,
      };
    },
    onScrollFunction(e) {
      let win_scroll_top = e.target.defaultView.pageYOffset;
      let win_height = window.innerHeight;
      let doc_height = document.body.scrollHeight;

      //console.log("win_scroll_top " + win_scroll_top);
      let width = $(".contain_width").width();
      //console.log("width " + width);
      if (win_scroll_top > 100) {
        $(".search_in_page").show();
        $(".search_in_page").css("width", width);
      } else {
        $(".search_in_page").hide();
      }
      /* if (win_scroll_top >= (doc_height - win_height) * 0.99) {
        if (!this.processing && this.canLoadMore) {
          this.pageActive += 1;
          //this.getEmployeeList('List');
          console.log('last');
        }
        if(this.processing && this.canLoadMore){
          console.log('not last');
        }
       }*/
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    viewdetail(docno) {
      this.form_dialog.details = [];
      DocumentService.getIncomeByCode(docno)
        .then((res) => {
          this.dialog = true;
          this.form_dialog.code = res.data.code;
          this.form_dialog.remark = res.data.remark;
          this.form_dialog.date = res.data.date;
          this.form_dialog.creator_code = res.data.creator_code;
          console.log(res);
          for (let index = 0; index < res.data.details.length; index++) {
            this.form_dialog.details.push({
              emp_code: res.data.details[index].emp_code,
              effect_date: res.data.details[index].effect_date,
              amount: res.data.details[index].amount,
              name: res.data.details[index].name,
              tax_type: res.data.details[index].tax_type,
              tax_percent: res.data.details[index].tax_percent,
              not_cal_tax: res.data.details[index].not_cal_tax,
              company_pay: res.data.details[index].company_pay,
              branch_pay : res.data.details[index].branch_pay,
              not_cal_ss: res.data.details[index].not_cal_ss,
            });
          }
          console.log(this.form_dialog);
          DocumentService.CheckDetail(this.form_dialog.details)
            .then((res) => {
              this.IncomeData = res.data;
              this.IncomeData.forEach((element) => {
                this.form_dialog.details.forEach((el) => {
                  if (element.emp_code == el.emp_code) {
                    element.tax_type = el.tax_type;
                    element.tax_percent = el.tax_percent;
                    element.not_cal_tax = el.not_cal_tax;
                    element.company_pay = el.company_pay;
                    element.branch_pay = el.branch_pay;
                   element.not_cal_ss = el.not_cal_ss;
                  }
                });
              });
              console.log(this.IncomeData);
            })
            .catch((err) => {
              this.snack_model.status = true;
              this.snack_model.msg = "ไม่พบข้อมูล";
              this.snack_model.type = "error";
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    deleteItem(code) {
      this.delete_dialog_data.status = true;
      let message = "<p>" + this.$t("question.delete") + " " + code;

      ("?</p>");
      this.delete_dialog_data.message = message;
      this.delete_dialog_data.code = code;
    },
    onDelete() {
      console.log("onDeleteDocument data: ", this.delete_dialog_data.code);
      DocumentService.deleteIncome(this.delete_dialog_data.code)
        .then((res) => {
          this.snack_model.status = true;
          this.snack_model.msg = this.$t("message.delete");
          this.snack_model.type = "success";
          this.pageActive = 1;
          this.table_data = [];
          this.getIncomeList();
          this.delete_dialog_data.status = false;
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        });
    },
    getIncomeList(Action) {
      this.commitSetShowLoading(true);
      this.table_data = [];
      if (this.FromDate == "" && this.ToDate == "") {
        DocumentService.getIncomeList(this.Search_data, this.pageActive, this.FromDate, this.ToDate)
          .then((res) => {
            // console.log(res);
            if (this.table_data.length > 0 && Action == "List") {
              if (res.data.content.length > 0) {
                res.data.content.forEach((data) => {
                  this.table_data.push(data);
                });
                this.totalPages = res.data.totalPages;
              } else {
                this.canLoadMore = false;
              }
            } else {
              this.table_data = res.data.content;
              this.totalPages = res.data.totalPages;
            }
          })
          .catch((err) => {
            this.commitToggleAlertDialog({
              status: true,
              message: err.response.data,
            });
          })
          .then(() => {
            this.commitSetShowLoading(false);
          });
      }
      if (this.FromDate != "" || this.ToDate != "") {
        DocumentService.getIncomeList(this.Search_data, this.pageActive, this.FromDate, this.ToDate)
          .then((res) => {
            // console.log(res);
            if (this.table_data.length > 0) {
              if (res.data.content.length > 0) {
                res.data.content.forEach((data) => {
                  this.table_data.push(data);
                });
              } else {
                this.canLoadMore = false;
              }
            } else {
              this.table_data = res.data.content;
            }
          })
          .catch((err) => {
            this.commitToggleAlertDialog({
              status: true,
              message: err.response.data,
            });
          })
          .then(() => {
            this.commitSetShowLoading(false);
          });
      }
      if (this.FromDate > this.ToDate && (this.FromDate != "" && this.ToDate != "")) {
        this.snack_model.status = true;
        this.snack_model.msg = this.$t("กรุณาระบุวันเริ่มต้นน้อยกว่าวันสิ้นสุด");
        this.snack_model.type = "error";
      }
    },
    deleteItemlistemp(data, index) {
      this.deldialog = true;
      this.form_deldialog = data;
      console.log(this.form_deldialog);
      this.index = index;
    },
    onDeleteEmp() {
      console.log(this.index);
      this.IncomeData.splice(this.index, 1);
      this.form_dialog.details.splice(this.index, 1);
      console.log("ondelete: importincome", this.form_dialog);
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");

span,
strong {
  font-family: "Prompt", sans-serif;
}
.back-ground-none {
  background: #ffffff;
  background-size: cover;
}
.setbox {
  padding: 0px !important;
  text-align: left;
  width: 100px;
}
.background {
  background: url("../../assets/banner1.png") no-repeat fixed top;
}
.triangle-topright {
  width: 0;
  height: 0;
  border-top: 20px solid #408550;
  border-right: 20px solid transparent;
  border-top-right-radius: 6px / 6px;
  float: right;
  margin-top: -16px;
  margin-left: -16px;
}
</style>
